import tabbedFeature from "./tabbed-feature";

var $verticalTabListItemFirst = $(".vertical-tab__item:first-child"),
  $verticalTabListItemContentFirst = $(
    ".vertical-tab__item-content:first-child"
  ),
  $verticalTabListItem = $(".vertical-tab__item"),
  $verticalTabListItemContent = $(".vertical-tab__item-content");

//Default first vertical tab should be active

$(document).ready(function() {
  $(".tab-link .tabs-nav a").click(function() {
    // $(".tabs-nav li").removeClass("tab-active");
    $(this).closest(".tabs-nav").find("li").removeClass("tab-active");
    $(this)
      .parent()
      .addClass("tab-active");
    // Display active tab
    let currentTab = $(this).attr("href");
    // $(".tab-content .tabbed-content").hide();
    $(this).closest(".tabbed-feature-component").find(".tab-content .tabbed-content").hide();
    $(currentTab).show();

    $verticalTabListItem.removeClass("active");
    $verticalTabListItemContent.removeClass("active");

    //Default first vertical tab should be active after tabbed change
    $verticalTabListItemFirst.addClass("active");
    $verticalTabListItemContentFirst.addClass("active");

    return false;
  });
});
